import React from 'react';
import styled from 'styled-components';
import { FiUser } from 'react-icons/fi';
import { Colors } from '../utils/colors';
import { Sizes } from '../utils/sizes';

const Wrap = styled.section`
  width: 100%;
  background: #111;
  padding: 80px 24px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.2), transparent);
  }
`;

const Inner = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 70px;

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    flex-direction: column;
    gap: 36px;
    text-align: center;
  }
`;

// const ImgWrap = styled.div`
//   flex-shrink: 0;
//   width: 280px;

//   @media (max-width: ${Sizes.mediaQueryBreak2}) {
//     width: 200px;
//   }

//   a { display: block; }

//   img {
//     width: 100%;
//     border-radius: 12px;
//     box-shadow: 0 20px 60px rgba(0,0,0,0.5);
//     transition: transform 0.2s;

//     &:hover { transform: scale(1.02); }
//   }
// `;

const TextWrap = styled.div`
  flex: 1;
`;

const Label = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 10px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 900;
  margin: 0 0 6px;

  span { color: ${Colors.yellow}; }
`;

const Sub = styled.p`
  color: rgba(255,255,255,0.5);
  font-size: 0.9rem;
  margin: 0 0 20px;
  font-style: italic;
`;

const Body = styled.p`
  color: rgba(255,255,255,0.7);
  font-size: 1rem;
  line-height: 1.75;
  margin: 0 0 28px;

  a {
    color: ${Colors.yellow};
    font-weight: 700;
    text-decoration: none;

    &:hover { text-decoration: underline; }
  }
`;

const Stats = styled.div`
  display: flex;
  gap: 28px;
  flex-wrap: wrap;

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    justify-content: center;
  }

  .stat {
    .num { color: ${Colors.yellow}; font-size: 1.5rem; font-weight: 900; }
    .lbl { color: rgba(255,255,255,0.45); font-size: 0.75rem; text-transform: uppercase; letter-spacing: 1px; }
  }
`;

const Section = () => (
  <Wrap>
    <Inner>
      {/* <ImgWrap>
        <a href="https://www.youtube.com/violaocatolico" target="_blank" rel="noreferrer">
          <img src="channel.png" alt="Canal Viola Católico no YouTube" />
        </a>
      </ImgWrap> */}
      <TextWrap>
        <Label><FiUser size={13} /> Quem está por trás</Label>
        <Title>Olá, eu sou <span>Márcio</span></Title>
        <Sub>Músico, professor e criador do Violão Católico</Sub>
        <Body>
          Quero te mostrar que é possível tocar violão sem complicação! Depois
          de 15 anos tocando, resolvi ajudar quem quer aprender. Já gravei mais
          de{' '}
          <a href="https://www.youtube.com/violaocatolico" target="_blank" rel="noreferrer">
            2 mil videoaulas no meu canal
          </a>{' '}
          ensinando de maneira fácil e prática. A missão é simples: colocar a
          música a serviço do povo de Deus.
        </Body>
        <Stats>
          <div className="stat">
            <div className="num">15+</div>
            <div className="lbl">Anos tocando</div>
          </div>
          <div className="stat">
            <div className="num">2k+</div>
            <div className="lbl">Videoaulas</div>
          </div>
          <div className="stat">
            <div className="num">500+</div>
            <div className="lbl">Cifras publicadas</div>
          </div>
        </Stats>
      </TextWrap>
    </Inner>
  </Wrap>
);

export default Section;
